var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"label"},[_vm._v("姓名")]),_c('div',{staticClass:"cont"},[_c('input',{attrs:{"type":"text","value":"","placeholder":"身份证号将加密处理"}})])]),_c('div',{staticClass:"explain"},[_vm._v("请填写本人身份信息")]),_c('div',{staticClass:"tips"},[_vm._v("身份信息错误")])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bac9aa72","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Form.vue
// module id = null
// module chunks = 